export interface OnDragEndParams {
  activeId: string;
  oldIndex: number;
  newIndex: number;
}

export interface OverlayComponentParams {
  activeId: string;
  activeIndex: number;
}

export enum SortableStrategy {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
  GRID = 'GRID',
}
